<template>
	<!-- 发票查询 -->
	<div class="page-container-query" id="ebOrderContainer">
		<el-form :model="ebOrder" ref="ruleFormRef" class="form-panel" label-position="top"
			:validateOnRuleChange="false">
			<el-col :span="24">
				<!-- <div> -->
				<el-row class="content-panel top-radius">
					<el-col style="height:12px;">
					</el-col>
						<el-row :gutter="22">

							<el-col :span="5">
								<el-form-item label="Reconciliation No:">
									<el-input size="mini" v-model="ebOrder.mblNo"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="5">
								<el-form-item label="Invoice No:">
									<el-input size="mini" v-model="ebOrder.agentCompNo"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="5">
								<el-form-item label="Issue Date Fm:">
									<el-date-picker
										style="width:100%;"
										align="right"
										type="date"
										size="mini"
										:placeholder="$t('table.selectTime')"
										:picker-options="pickerOptions"
										v-model="ebOrder.createTimeStart"
                    value-format="yyyy-MM-dd HH:mm:ss"
										>
									</el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="5">
								<el-form-item label="Issue Date To:">
									<el-date-picker
										style="width:100%;"
										align="right"
										type="date"
										size="mini"
										:placeholder="$t('table.selectTime')"
										:picker-options="pickerOptions"
										v-model="ebOrder.createTimeEnd"
                    value-format="yyyy-MM-dd HH:mm:ss"
										>
									</el-date-picker>
								</el-form-item>
							</el-col>
							<el-col :span="4">
								<el-form-item label="Invoice Type:">
									<el-select
										class="length_input"
										size="mini"
										v-model="ebOrder.invoiceType"
										:placeholder="$t('table.pleaseSelect')"
										clearable
										>
										<el-option
											v-for="item in invoiceTypeList"
											:key="item.key"
											:label="item.value"
											:value="item.key"
										>
										</el-option>
									</el-select>
								</el-form-item>
							</el-col>
						</el-row>
					<el-col style="height:2px;">
					</el-col>
					<el-row type="flex" align="center" justify="end">
							<el-button type="primary" size="small" plain @click="queryForm">Search</el-button>
						    <el-button type="primary" size="small" plain @click="handlerReset">Reset</el-button>
					</el-row>
				</el-row>

				<!-- </div> -->

				<!-- 表格-start -->
				<el-row style="margin-top: 15px">
					<hot-table ref="ebOrderTableRef" :data-source="ebOrderTableDataSource"
						:settings="ebOrderTableSettings" col-settings-key="ebOrder" @cellDblclick="toInvoiceDetail">
						<hot-column :has-tip="true" data="mblNo" title="Reconciliation NO." width="150">
						</hot-column>
						<hot-column :has-tip="true" data="agentCompNo" title="Invoice NO." width="150">
						</hot-column>

						<hot-column :has-tip="true" data="createTime" title="Issue Date." width="150" date-format="YYYY-MM-DD">
						</hot-column>

						<hot-column :has-tip="true" data="invoiceType" title="Invoice Type" width="150">
						</hot-column>
						<hot-column :has-tip="true" data="settleAgentName" title="Buyer" width="150">
						</hot-column>
						<hot-column :has-tip="true" data="unifiedCreditNo" title="Taxpayer Identification ID" width="150">
						</hot-column>
						<hot-column :has-tip="true" data="invoiceAmount" title="Invoice Amount" width="150">
						</hot-column>
					</hot-table>
          <!-- 分页start -->
          <div class="pg_div">
            <el-pagination :current-page="pageConfig.currentPage" :layout="pageConfig.layout"
                           :page-size="pageConfig.pageSize" :page-sizes="pageConfig.pageSizes" :total="pageConfig.total"
                           @current-change="handleCurrentChange" @size-change="handleSizeChange" />
          </div>
          <!-- 分页end -->

				</el-row>
			</el-col>
			<!-- 表格-end -->
		</el-form>
	</div>
</template>

<script>
	import ebOrder from "@/api/ebOrder";
	import { queryInvoiceInfo } from '@/api/overseas'
import { title } from '@/settings';
  import {queryDictRows,queryDictionaryByCodeType} from "@/api/commonService";
import { query } from '@/api/ebCargo';
	export default {
		name: 'InvoiceQuery',
		data() {
			return {
				//日期设置
				pickerOptions: {
					// disabledDate(time) {
					// 	return time.getTime() > Date.now();
					// },
					shortcuts: [{
						text: this.$t('table.today'),
						onClick(picker) {
							picker.$emit('pick', new Date());
						}
					}, {
						text: this.$t('table.yesterday'),
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24);
							picker.$emit('pick', date);
						}
					}, {
						text: this.$t('table.aWeekAgo'),
						onClick(picker) {
							const date = new Date();
							date.setTime(date.getTime() - 3600 * 1000 * 24 * 7);
							picker.$emit('pick', date);
						}
					}]
				},
				ebOrder: {
					mblNo: '',
					agentCompNo: '',
					createTimeStart: '',
					createTimeEnd: '',
					invoiceType: 'INVOICE',
				},
				mainOrder: {
					atdFrom: '',
					atdTo: '',
					ataFrom: '',
					ataTo: '',
					projectNo: '',
				},
				// 分页
				pageConfig: {
					layout: 'total, sizes, prev, pager, next, jumper',
					total: 0,
					pageSize: 10,
					pagerCount: 10,
					currentPage: 1,
					pageSizes: [10, 20, 50, 100]
				},
        invoiceTypeList: [],
				// 表格校验
				ebOrderRules: {},
				// 表格数据
				ebOrderTableDataSource: [],
				// 表格设置
				ebOrderTableSettings: {
					height: 420,
					stretchH: 'all', // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
					...this.$systemConfig.tableConfig

				},
             custId: '',
			};
		},
    async created() {

    },
		mounted() {
			let self = this
            self.queryDict();
			let userInfo=JSON.parse(localStorage.getItem('userInfo'))
            this.custId = userInfo.custId;
		    self.pageID = document.getElementById('ebOrderContainer')
             // this.$tableAdaptation.tableAdaptation(self.pageID,self.ebOrderTableSettings)
			// 监听外层容器div宽度的变化，做表格自适应
			this.ebOrderTableSettings.height = document.body.clientHeight - 260
			self.resizeObserver = new ResizeObserver(entries => {
				self.$nextTick(() => {
					self.$refs.ebOrderTableRef.resizeTo(entries[0].target.clientWidth - 20)
				})
			})
			self.resizeObserver.observe(document.getElementById("ebOrderContainer"))
		},
		methods: {
			/* 表格双击跳转 */
			toInvoiceDetail(val){
				let bcAgentCompId = val.record.bcAgentCompId
				this.$router.push({
					path: "/overseas-agency/InvoiceDetail",
					query: {
						bcAgentCompId: bcAgentCompId,
            invoiceType: this.ebOrder.invoiceType
					}
				})
			},
			//点击
			queryForm() {
				let self = this
				var queryData ={}
			    var	ebOrder = this.ebOrder
			     for(let i in ebOrder){
					  if(ebOrder[i]){
						  queryData[i]=ebOrder[i]
					    }
				    }
				 queryData.page=this.pageConfig.currentPage
				 queryData.pageSize=this.pageConfig.pageSize
				 queryData.settleAgentId= this.custId
			/* 	queryData.settleAgentId= '6843204958103347200' */
				 if(queryData.mblNo){
					 queryData.mblNo="%"+this.ebOrder.mblNo+"%"
				 }
				 if(queryData.agentCompNo){
					 queryData.agentCompNo="%"+this.ebOrder.agentCompNo+"%"
				 }
				 if(queryData.settleAgentId){
				 queryInvoiceInfo(queryData).then(result => {
					self.ebOrderTableDataSource = result.records.records
           self.pageConfig.total = result.records.totalRecord;
				 })
				 }else{
				   this.$coreMethods.message(
                   "warning",this.$t('message.noMerchantFound'));
				 }
			},
			handlerReset(){
				this.ebOrder = {
            mblNo: '',
            agentCompNo: '',
            createTimeStart: '',
            createTimeEnd: '',
            invoiceType: 'INVOICE',
        }
			},
      queryDict() {
        let self = this;
	    let params={
          codeType: "MD_INVOICE_TYPE",
		  valueType: 'ZH',
        }
		 if(this.$cookies.get('language')==='en'){
		  params={
          codeType: "MD_INVOICE_TYPE",
		  valueType: 'EN',
        }
		 }
        queryDictionaryByCodeType(params).then((res) => {
          let dict = [];
          // res.MD_CODE_DICT$MD_INVOICE_TYPE.forEach((item) => {
          //   let param = {};
          //   param.value = item.value;
          //   param.key = item.key;
          //   param.count = 0;
          //   param.filterList = [];
          //   dict.push(param);
          //   self.invoiceTypeList.push(param);
          // });
          self.invoiceTypeList = res.records.MD_INVOICE_TYPE;
          console.log("invoiceTypeList", dict);
          // 数据字典
          // self.$hotTableUtils.registDict({EB_OS_ORDER_TYPE: dict});
        });
      },
						// currentPage 改变时会触发
			handleCurrentChange(val) {
				console.log(`当前页: ${val}`)
				this.pageConfig.currentPage = val
				let self = this;
				self.queryForm()
			},
			handleSizeChange(val){
				this.pageConfig.pageSize = val
				let self = this;
					self.queryForm()
			},
		}
	};
</script>

<style scoped lang="scss">
.page-container-query{
 height: unset !important;
}
</style>
